import { saveAs } from 'file-saver'
import {
  DATA_LOADED,
  QUARTERLY_STATEMENTS,
  REPORT_LOADING,
  REPORT_ERROR,
  NO_DATA_ERROR,
  VIS_ERROR_OCCURED,
  SET_DATA_LOADED,
  SET_QUARTERLY_STATEMENTS,
  SET_REPORT_LOADING,
  SET_REPORT_ERROR,
  SET_NO_DATA_ERROR,
  SET_VIS_ERROR_OCCURED,
  UPDATE_QUARTERLY_STATMENTS,
  DOWNLOAD_EXCEL_REPORT,
  ACKNOWLEDGE_ERRORS,
} from '../quarterly-statement-types'

import {
  getAvailableQuarterlyReports,
  downloadQuarterlyReport,
} from '@/services/api/LF/lf-api-helper'

const state = {
  dataLoaded: false,
  quarterlyStatements: [],
  reportLoading: false,
  reportError: false,
  noDataError: false,
  visErrorOccured: null,
}

const getters = {
  [DATA_LOADED](state) {
    return state.dataLoaded
  },
  [QUARTERLY_STATEMENTS](state) {
    return state.quarterlyStatements
  },
  [REPORT_LOADING](state) {
    return state.reportLoading
  },
  [REPORT_ERROR](state) {
    return state.reportError
  },
  [NO_DATA_ERROR](state) {
    return state.noDataError
  },
  [VIS_ERROR_OCCURED](state) {
    return state.visErrorOccured
  },
}

const mutations = {
  [SET_DATA_LOADED](state, payload) {
    state.dataLoaded = payload
  },
  [SET_QUARTERLY_STATEMENTS](state, payload) {
    state.quarterlyStatements = payload
  },
  [SET_REPORT_LOADING](state, payload) {
    state.reportLoading = payload
  },
  [SET_REPORT_ERROR](state, payload) {
    state.reportError = payload
  },
  [SET_NO_DATA_ERROR](state, payload) {
    state.noDataError = payload
  },
  [SET_VIS_ERROR_OCCURED](state, payload) {
    state.visErrorOccured = payload
  },
}

const actions = {
  [UPDATE_QUARTERLY_STATMENTS]({ commit, rootState }) {
    // The viewReportAs.userId from the vuex reports module enables
    // admin users to emulate other users/clients
    // This action does not accept any parameters so a filterParameters
    // object is created
    let filterParameters = {
      viewAsUserId: rootState.reports.viewReportAs?.userId ?? 0,
    }

    commit(SET_DATA_LOADED, false)
    getAvailableQuarterlyReports(
      filterParameters,
      (data) => {
        commit(SET_QUARTERLY_STATEMENTS, data) // on success
        commit(SET_DATA_LOADED, true)
        commit(SET_NO_DATA_ERROR, checkForNoDataError(data))
      },
      (jqXHR) => {
        commit(SET_QUARTERLY_STATEMENTS, []) // on fail
        commit(SET_VIS_ERROR_OCCURED, jqXHR)
        commit(SET_DATA_LOADED, true)
      },
    )
  },
  [DOWNLOAD_EXCEL_REPORT]({ commit, rootState }, reportGuid) {
    // The viewReportAs.userId from the vuex reports module enables
    // admin users to emulate other users/clients
    // This action accepts a reportGuid which represents the report
    // to download. The filter parameters object is created which
    // encapsulates the reportGuid and the userId to emulate
    let filterParameters = {
      reportGuid,
      viewAsUserId: rootState.reports.viewReportAs?.userId ?? 0,
    }
    commit(SET_REPORT_LOADING, true)
    downloadQuarterlyReport(
      filterParameters,
      (data) => {
        let blob = b64toBlob(data.file_binary, data.file_extension)
        let filename = `${data.statement_name}`
        saveAs(blob, filename)
        commit(SET_REPORT_LOADING, false)
        commit(SET_REPORT_ERROR, null)
      },
      (jqXHR) => {
        commit(SET_REPORT_LOADING, false)
        commit(SET_REPORT_ERROR, jqXHR)
      },
    )
  },
  [ACKNOWLEDGE_ERRORS]({ commit }) {
    commit(SET_NO_DATA_ERROR, false)
    commit(SET_VIS_ERROR_OCCURED, null)
    commit(SET_REPORT_ERROR, null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

const contentTypes = {
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xls': 'application/vnd.ms-excel',
  '.pdf': 'application/pdf',
}

// helper methods
const b64toBlob = (b64Data, fileExtension = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentTypes[fileExtension] })
}

const checkForNoDataError = (data) => {
  if (!(data && data.length)) return true
  else return false
}
